import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the home state domain
 */

const selectHomeDomain = state => state.home || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Home
 */

const selectHomeLoading = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.loading,
  );

const selectHomeError = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.error,
  );

export {
  selectHomeDomain,
  selectHomeLoading,
  selectHomeError,
};
